"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var PREFIX = 'ChatIcon';
var classes = {
    main: "".concat(PREFIX, "-main"),
};
var StyledSvgIcon = (0, styles_1.styled)(material_1.SvgIcon)((_a = {},
    _a["&.".concat(classes.main)] = {
        stroke: 'black',
    },
    _a));
var ClockIcon = function (props) {
    return ((0, jsx_runtime_1.jsxs)(StyledSvgIcon, __assign({ fontSize: "small" }, props, { fill: "none", viewBox: "0 0 24 24", style: __assign({ color: 'transparent' }, props.style), className: (0, classnames_1.default)(classes.main, props.className) }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z", stroke: "#FF4F6B", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), (0, jsx_runtime_1.jsx)("path", { d: "M12 6.75V12H17.25", stroke: "#FF4F6B", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
};
exports.default = ClockIcon;
